
  <div *ngIf="currentUser">
    <table class="table" style="background-color:white;">
      <tr>
        <td style="background-color:#0f2b46;color:white;" colspan="2">Corporate/Company Store List </td>
        <td style="text-align: right;background-color: #0f2b46;color: white;padding-right: 32px;"><mat-icon [mat-dialog-close]="false">close</mat-icon></td>
      </tr>
    </table>

    <div>
      <table class="table table-hover text-center  table-bordered table-responsive" border="1">
        <thead class="theme-button">
          <tr>
            <th scope="col">Entry Date</th>
            <th scope="col">Qr Code</th>
            <th scope="col">Store Countryid</th>
            <th scope="col">Store Name</th>
            <th scope="col">Store Address</th>
            <th scope="col">Store City</th>
            <th scope="col">Description</th>
          </tr>
        </thead>

        <tbody *ngFor="let x of merchantstorelist; let i=index">
          <tr>
            <td>{{x.entryDate |date}}</td>
            <td>
              <img id="doc1" src="{{x.qrCodepath}}" style="width:100px;height:100px;" /> <br />
              <button *ngIf="x.qrCodepath" class="buttonlnk" (click)="openVerticallyCentered(content,x.qrCodepath,x.storeName)">Click to expand </button>

            </td>
            <td>{{x.storeCountryid}}</td>
            <td>{{x.storeName}}</td>
            <td>{{x.storeAddress}}</td>
            <td>{{x.storeCity}}</td>
            <td>{{x.description}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>


  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Qr Code Image of : {{xstoreName}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <img [src]="xImage" class="img-fluid" />
    </div>
  </ng-template>
